"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportError = void 0;
var tslib_1 = require("tslib");
/**
 * An error originating from the Transport class.
 */
var TransportError = /** @class */ (function (_super) {
    tslib_1.__extends(TransportError, _super);
    function TransportError(code, message, origin) {
        if (origin === void 0) { origin = null; }
        var _this = _super.call(this, message) || this;
        _this.name = 'TransportError';
        _this.message = message;
        _this.code = code;
        _this.origin = origin;
        return _this;
    }
    return TransportError;
}(Error));
exports.TransportError = TransportError;
//# sourceMappingURL=transport.js.map